var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignFlowsheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32.0674V5.46699H36.9875V11.9341H41.4542V30.5212H10.2935V23.3207H4.37348V18.9471H0V0ZM10.2935 21.3207V11.9341H34.9875V7.46699H6.37348V21.3207L10.2935 21.3207ZM30.0674 2V5.46699H4.37348V16.9471H2V2H30.0674ZM21.4541 20.3208C23.111 20.3208 24.4541 18.9777 24.4541 17.3208C24.4541 15.6639 23.111 14.3208 21.4541 14.3208C19.7972 14.3208 18.4541 15.6639 18.4541 17.3208C18.4541 18.9777 19.7972 20.3208 21.4541 20.3208ZM34.4541 14.3208H28.4541V20.3208H34.4541V14.3208ZM24.4541 28.3208L21.4541 22.3208L18.4541 28.3208H24.4541ZM28.4541 22.3208V28.3208H34.4541L28.4541 22.3208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignFlowsheet);
export default __webpack_public_path__ + "static/media/DesignFlowsheet.1d63327dcb104852716fd881ce99a035.svg";
export { ForwardRef as ReactComponent };